module.exports = __webpack_public_path__ + "img/080-iceland.2c2c2b7d.svg";